export default __webpack_public_path__ + "static/media/bnr9.802e1f5d.jpg";